"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.INITIAL_STATE = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _variables = require("../variables");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var INITIAL_STATE = exports.INITIAL_STATE = {
  amenitiesUsageByDay: [],
  amenitiesUsageByAmenity: [],
  errorUsageByDay: false,
  errorUsageByAmenity: false,
  createAmenityError: false,
  editAmenityError: false,
  getAmenityError: false,
  listAmenitiesError: false,
  listAmenitiesReservationsError: false,
  listAmenitiesAcceptedReservationsError: false,
  listAmenitiesPendingReservationsError: false,
  loading: false,
  loadingReservations: false,
  loadingAcceptedReservations: false,
  loadingPendingReservations: false,
  loadingDayAvailability: false,
  loadingReservationEndPeriods: false,
  loadingAmenitiesUsageByDay: false,
  loadingAmenitiesUsageByAmenity: false,
  loadingAcceptReservation: false,
  loadingRejectReservation: false,
  errorAcceptReservation: false,
  errorRejectReservation: false,
  errorReservationEndPeriods: false,
  errorDayAvailability: false,
  createAmenityReservationError: false,
  deleteAmenityReservationError: false,
  deleteAmenityError: false,
  editAmenityReservationError: false,
  loadingCheckout: false,
  loadingPendentCheckout: false,
  errorPendentCheckoutsList: false,
  errorCheckout: false,
  loadingMonthAvailability: false,
  errorMonthAvailability: false,
  loadingListEntries: false,
  errorListEntries: false,
  listEntriesPageCount: 0,
  listEntriesTotalCount: 0,
  listEntries: [],
  listBlocks: [],
  listBlocksPageCount: 0,
  listBlocksTotalCount: 0,
  loadingListBlocks: false,
  errorListBlocks: false,
  loadingStockMovement: false,
  errorStockMovement: false,
  stockMovementPageCount: 0,
  stockMovementTotalCount: 0,
  stockMovement: [],
  monthAvailability: [],
  totalReservationsCount: 0,
  totalReservationsPages: 0,
  totalAcceptedReservationsCount: 0,
  totalAcceptedReservationsPages: 0,
  totalPendingReservationsCount: 0,
  totalPendingReservationsPages: 0,
  totalActiveUsersCount: 0,
  totalActiveUsersPages: 0,
  loadingMoveStock: false,
  errorMoveStock: false,
  dayAvailability: [],
  reservationEndPeriods: [],
  pendentCheckoutsList: [],
  reservationsList: [],
  reservationsAcceptedList: [],
  reservationsPendingList: [],
  list: [],
  data: {},
  reservationData: {},
  loadingBlockAmenity: false,
  errorBlockAmenity: false,
  finishEntryLoading: false,
  finishEntryError: false,
  generateLostStockReportLoading: false,
  generateLostStockReportError: false,
  ability: {},
  loadingAmenityAbility: false,
  errorAmenityAbility: false
};
var _default = exports["default"] = function _default() {
  var _action$payload$data, _action$payload, _action$payload$data2, _action$payload2, _action$payload$data3, _action$payload3, _action$payload$data4, _action$payload4, _action$payload$data5, _action$payload5, _action$payload$data6, _action$payload6, _action$payload$data7, _action$payload7, _action$payload$data8, _action$payload8, _action$payload$data9, _action$payload9, _action$payload$data10, _action$payload10, _action$payload$data11, _action$payload11, _action$payload$data12, _action$payload12, _action$payload$data13, _action$payload13, _action$payload$data14, _action$payload14, _action$payload$data15, _action$payload15, _action$payload$data16, _action$payload16, _action$payload$data17, _action$payload17, _action$payload$data18, _action$payload18, _action$payload$data19, _action$payload19, _action$payload$data20, _action$payload20, _action$payload$data21, _action$payload21, _action$payload$data22, _action$payload22, _action$payload$data23, _action$payload23, _action$payload$data24, _action$payload24, _action$payload$data25, _action$payload25, _action$payload$data26, _action$payload26, _action$payload$data27, _action$payload27, _action$payload$data28, _action$payload28, _action$payload$data29, _action$payload29, _action$payload$data30, _action$payload30, _action$payload$data31, _action$payload31, _action$payload$data32, _action$payload32, _action$payload$data33, _action$payload33, _action$payload$data34, _action$payload34, _action$payload$data35, _action$payload35, _action$payload$data36, _action$payload36, _action$payload$data37, _action$payload37, _action$payload$data38, _action$payload38, _action$payload$data39, _action$payload39, _action$payload$data40, _action$payload40, _action$payload$data41, _action$payload41, _action$payload$data42, _action$payload42, _action$payload$data43, _action$payload43, _action$payload$data44, _action$payload44, _action$payload$data45, _action$payload45, _action$payload$data46, _action$payload46, _action$payload$data47, _action$payload47, _action$payload$data48, _action$payload48, _action$payload$data49, _action$payload49;
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case _variables.AMENITY_ABILITY_REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingAmenityAbility: true,
        errorAmenityAbility: false
      });
    case _variables.AMENITY_ABILITY_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingAmenityAbility: false,
        ability: (_action$payload$data = action === null || action === void 0 || (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.data) !== null && _action$payload$data !== void 0 ? _action$payload$data : []
      });
    case _variables.AMENITY_ABILITY_FAIL:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingAmenityAbility: false,
        errorAmenityAbility: (_action$payload$data2 = action === null || action === void 0 || (_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.data) !== null && _action$payload$data2 !== void 0 ? _action$payload$data2 : {}
      });
    case _variables.AMENITIES_USAGE_BY_DAY_REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingAmenitiesUsageByDay: true,
        errorUsageByDay: false
      });
    case _variables.AMENITIES_USAGE_BY_DAY_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingAmenitiesUsageByDay: false,
        amenitiesUsageByDay: (_action$payload$data3 = action === null || action === void 0 || (_action$payload3 = action.payload) === null || _action$payload3 === void 0 ? void 0 : _action$payload3.data) !== null && _action$payload$data3 !== void 0 ? _action$payload$data3 : []
      });
    case _variables.AMENITIES_USAGE_BY_DAY_FAIL:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingAmenitiesUsageByDay: false,
        errorUsageByDay: (_action$payload$data4 = action === null || action === void 0 || (_action$payload4 = action.payload) === null || _action$payload4 === void 0 ? void 0 : _action$payload4.data) !== null && _action$payload$data4 !== void 0 ? _action$payload$data4 : {}
      });
    case _variables.AMENITIES_USAGE_BY_AMENITY_REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingAmenitiesUsageByAmenity: true,
        errorUsageByAmenity: false
      });
    case _variables.AMENITIES_USAGE_BY_AMENITY_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingAmenitiesUsageByAmenity: false,
        amenitiesUsageByAmenity: (_action$payload$data5 = action === null || action === void 0 || (_action$payload5 = action.payload) === null || _action$payload5 === void 0 ? void 0 : _action$payload5.data) !== null && _action$payload$data5 !== void 0 ? _action$payload$data5 : []
      });
    case _variables.AMENITIES_USAGE_BY_AMENITY_FAIL:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingAmenitiesUsageByAmenity: false,
        errorUsageByAmenity: (_action$payload$data6 = action === null || action === void 0 || (_action$payload6 = action.payload) === null || _action$payload6 === void 0 ? void 0 : _action$payload6.data) !== null && _action$payload$data6 !== void 0 ? _action$payload$data6 : {}
      });
    case _variables.FINISH_AMENITY_ENTRY_REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        finishEntryLoading: true,
        finishEntryError: false
      });
    case _variables.FINISH_AMENITY_ENTRY_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        finishEntryLoading: false,
        finishEntryError: false
      });
    case _variables.FINISH_AMENITY_ENTRY_FAIL:
      return _objectSpread(_objectSpread({}, state), {}, {
        finishEntryLoading: false,
        finishEntryError: (_action$payload$data7 = action === null || action === void 0 || (_action$payload7 = action.payload) === null || _action$payload7 === void 0 ? void 0 : _action$payload7.data) !== null && _action$payload$data7 !== void 0 ? _action$payload$data7 : {}
      });
    case _variables.BLOCK_AMENITY_REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingBlockAmenity: true,
        errorBlockAmenity: false
      });
    case _variables.BLOCK_AMENITY_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingBlockAmenity: false,
        errorBlockAmenity: false
      });
    case _variables.BLOCK_AMENITY_FAIL:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingBlockAmenity: false,
        errorBlockAmenity: (_action$payload$data8 = action === null || action === void 0 || (_action$payload8 = action.payload) === null || _action$payload8 === void 0 ? void 0 : _action$payload8.data) !== null && _action$payload$data8 !== void 0 ? _action$payload$data8 : {}
      });
    case _variables.REPLENISH_AMENITY_STOCK_REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingMoveStock: true,
        errorMoveStock: false
      });
    case _variables.REPLENISH_AMENITY_STOCK_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingMoveStock: false,
        errorMoveStock: false
      });
    case _variables.REPLENISH_AMENITY_STOCK_FAIL:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingMoveStock: false,
        errorMoveStock: (_action$payload$data9 = action === null || action === void 0 || (_action$payload9 = action.payload) === null || _action$payload9 === void 0 ? void 0 : _action$payload9.data) !== null && _action$payload$data9 !== void 0 ? _action$payload$data9 : {}
      });
    case _variables.DEBIT_AMENITY_STOCK_REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingMoveStock: true,
        errorMoveStock: false
      });
    case _variables.DEBIT_AMENITY_STOCK_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingMoveStock: false,
        errorMoveStock: false
      });
    case _variables.DEBIT_AMENITY_STOCK_FAIL:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingMoveStock: false,
        errorMoveStock: (_action$payload$data10 = action === null || action === void 0 || (_action$payload10 = action.payload) === null || _action$payload10 === void 0 ? void 0 : _action$payload10.data) !== null && _action$payload$data10 !== void 0 ? _action$payload$data10 : {}
      });
    case _variables.LIST_AMENITIES_STOCK_MOVEMENT_REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingStockMovement: true,
        errorStockMovement: false
      });
    case _variables.LIST_AMENITIES_STOCK_MOVEMENT_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingStockMovement: false,
        errorStockMovement: false,
        stockMovement: (_action$payload$data11 = action === null || action === void 0 || (_action$payload11 = action.payload) === null || _action$payload11 === void 0 ? void 0 : _action$payload11.data) !== null && _action$payload$data11 !== void 0 ? _action$payload$data11 : [],
        stockMovementPageCount: action.payload.headers['total-pages'],
        stockMovementTotalCount: action.payload.headers['total-count']
      });
    case _variables.LIST_AMENITIES_STOCK_MOVEMENT_FAIL:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingStockMovement: false,
        errorStockMovement: (_action$payload$data12 = action === null || action === void 0 || (_action$payload12 = action.payload) === null || _action$payload12 === void 0 ? void 0 : _action$payload12.data) !== null && _action$payload$data12 !== void 0 ? _action$payload$data12 : {}
      });
    case _variables.LIST_AMENITIES_BLOCKS_REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingListBlocks: true,
        errorListBlocks: false
      });
    case _variables.LIST_AMENITIES_BLOCKS_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingListBlocks: false,
        errorListBlocks: false,
        listBlocks: (_action$payload$data13 = action === null || action === void 0 || (_action$payload13 = action.payload) === null || _action$payload13 === void 0 ? void 0 : _action$payload13.data) !== null && _action$payload$data13 !== void 0 ? _action$payload$data13 : [],
        listBlocksPageCount: action.payload.headers['total-pages'],
        listBlocksTotalCount: action.payload.headers['total-count']
      });
    case _variables.LIST_AMENITIES_BLOCKS_FAIL:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingListBlocks: false,
        errorListBlocks: (_action$payload$data14 = action === null || action === void 0 || (_action$payload14 = action.payload) === null || _action$payload14 === void 0 ? void 0 : _action$payload14.data) !== null && _action$payload$data14 !== void 0 ? _action$payload$data14 : {}
      });
    case _variables.LIST_AMENITIES_ENTRIES_REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingListEntries: true,
        errorListEntries: false
      });
    case _variables.LIST_AMENITIES_ENTRIES_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingListEntries: false,
        errorListEntries: false,
        listEntries: (_action$payload$data15 = action === null || action === void 0 || (_action$payload15 = action.payload) === null || _action$payload15 === void 0 ? void 0 : _action$payload15.data) !== null && _action$payload$data15 !== void 0 ? _action$payload$data15 : [],
        listEntriesPageCount: action.payload.headers['total-pages'],
        listEntriesTotalCount: action.payload.headers['total-count']
      });
    case _variables.LIST_AMENITIES_ENTRIES_FAIL:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingListEntries: false,
        errorListEntries: (_action$payload$data16 = action === null || action === void 0 || (_action$payload16 = action.payload) === null || _action$payload16 === void 0 ? void 0 : _action$payload16.data) !== null && _action$payload$data16 !== void 0 ? _action$payload$data16 : {}
      });
    case _variables.GET_RESERVATION_END_PERIODS_REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingReservationEndPeriods: true,
        errorReservationEndPeriods: null
      });
    case _variables.GET_RESERVATION_END_PERIODS_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingReservationEndPeriods: false,
        reservationEndPeriods: (_action$payload$data17 = action === null || action === void 0 || (_action$payload17 = action.payload) === null || _action$payload17 === void 0 ? void 0 : _action$payload17.data) !== null && _action$payload$data17 !== void 0 ? _action$payload$data17 : []
      });
    case _variables.GET_RESERVATION_END_PERIODS_FAIL:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingReservationEndPeriods: false,
        errorReservationEndPeriods: (_action$payload$data18 = action === null || action === void 0 || (_action$payload18 = action.payload) === null || _action$payload18 === void 0 ? void 0 : _action$payload18.data) !== null && _action$payload$data18 !== void 0 ? _action$payload$data18 : {}
      });
    case _variables.GET_MONTH_AVAILABILITY_REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingMonthAvailability: true,
        errorMonthAvailability: null
      });
    case _variables.GET_MONTH_AVAILABILITY_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingMonthAvailability: false,
        monthAvailability: (_action$payload$data19 = action === null || action === void 0 || (_action$payload19 = action.payload) === null || _action$payload19 === void 0 ? void 0 : _action$payload19.data) !== null && _action$payload$data19 !== void 0 ? _action$payload$data19 : []
      });
    case _variables.GET_MONTH_AVAILABILITY_FAIL:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingMonthAvailability: false,
        errorMonthAvailability: (_action$payload$data20 = action === null || action === void 0 || (_action$payload20 = action.payload) === null || _action$payload20 === void 0 ? void 0 : _action$payload20.data) !== null && _action$payload$data20 !== void 0 ? _action$payload$data20 : {}
      });
    case _variables.GET_DAY_AVAILABILITY_REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingDayAvailability: true,
        errorDayAvailability: null
      });
    case _variables.GET_DAY_AVAILABILITY_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingDayAvailability: false,
        dayAvailability: (_action$payload$data21 = action === null || action === void 0 || (_action$payload21 = action.payload) === null || _action$payload21 === void 0 ? void 0 : _action$payload21.data) !== null && _action$payload$data21 !== void 0 ? _action$payload$data21 : []
      });
    case _variables.GET_DAY_AVAILABILITY_FAIL:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingDayAvailability: false,
        errorDayAvailability: (_action$payload$data22 = action === null || action === void 0 || (_action$payload22 = action.payload) === null || _action$payload22 === void 0 ? void 0 : _action$payload22.data) !== null && _action$payload$data22 !== void 0 ? _action$payload$data22 : {}
      });
    case _variables.DELETE_AMENITY_REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: true,
        deleteAmenityError: null
      });
    case _variables.DELETE_AMENITY_FAIL:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: false,
        deleteAmenityError: (_action$payload$data23 = action === null || action === void 0 || (_action$payload23 = action.payload) === null || _action$payload23 === void 0 ? void 0 : _action$payload23.data) !== null && _action$payload$data23 !== void 0 ? _action$payload$data23 : {}
      });
    case _variables.DELETE_AMENITY_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: false
      });
    case _variables.LIST_PENDENT_CHECKOUTS_REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingPendentCheckout: true
      });
    case _variables.LIST_PENDENT_CHECKOUTS_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingPendentCheckout: false,
        pendentCheckoutsList: (_action$payload$data24 = action === null || action === void 0 || (_action$payload24 = action.payload) === null || _action$payload24 === void 0 ? void 0 : _action$payload24.data) !== null && _action$payload$data24 !== void 0 ? _action$payload$data24 : [],
        errorPendentCheckoutsList: null,
        totalActiveUsersCount: action.payload.headers['total-count'],
        totalActiveUsersPages: action.payload.headers['total-pages']
      });
    case _variables.LIST_PENDENT_CHECKOUTS_FAIL:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingPendentCheckout: false,
        errorPendentCheckoutsList: (_action$payload$data25 = action === null || action === void 0 || (_action$payload25 = action.payload) === null || _action$payload25 === void 0 ? void 0 : _action$payload25.data) !== null && _action$payload$data25 !== void 0 ? _action$payload$data25 : {}
      });
    case _variables.CHECKOUT_REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingCheckout: true
      });
    case _variables.CHECKOUT_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingCheckout: false,
        errorCheckout: null
      });
    case _variables.CHECKOUT_FAIL:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingCheckout: false,
        errorCheckout: (_action$payload$data26 = action === null || action === void 0 || (_action$payload26 = action.payload) === null || _action$payload26 === void 0 ? void 0 : _action$payload26.data) !== null && _action$payload$data26 !== void 0 ? _action$payload$data26 : {}
      });
    case _variables.LIST_AMENITIES_REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: true
      });
    case _variables.LIST_AMENITIES_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: false,
        list: (_action$payload$data27 = action === null || action === void 0 || (_action$payload27 = action.payload) === null || _action$payload27 === void 0 ? void 0 : _action$payload27.data) !== null && _action$payload$data27 !== void 0 ? _action$payload$data27 : [],
        listAmenitiesError: null
      });
    case _variables.LIST_AMENITIES_FAIL:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: false,
        listAmenitiesError: (_action$payload$data28 = action === null || action === void 0 || (_action$payload28 = action.payload) === null || _action$payload28 === void 0 ? void 0 : _action$payload28.data) !== null && _action$payload$data28 !== void 0 ? _action$payload$data28 : {}
      });
    case _variables.LIST_AMENITIES_RESERVATIONS_REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingReservations: true
      });
    case _variables.LIST_AMENITIES_RESERVATIONS_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingReservations: false,
        reservationsList: (_action$payload$data29 = action === null || action === void 0 || (_action$payload29 = action.payload) === null || _action$payload29 === void 0 ? void 0 : _action$payload29.data) !== null && _action$payload$data29 !== void 0 ? _action$payload$data29 : [],
        listAmenitiesReservationsError: null,
        totalReservationsCount: action.payload.headers['total-count'],
        totalReservationsPages: action.payload.headers['total-pages']
      });
    case _variables.LIST_AMENITIES_RESERVATIONS_FAIL:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingReservations: false,
        listAmenitiesReservationsError: (_action$payload$data30 = action === null || action === void 0 || (_action$payload30 = action.payload) === null || _action$payload30 === void 0 ? void 0 : _action$payload30.data) !== null && _action$payload$data30 !== void 0 ? _action$payload$data30 : {}
      });
    case _variables.LIST_AMENITIES_ACCEPTED_RESERVATIONS_REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingAcceptedReservations: true
      });
    case _variables.LIST_AMENITIES_ACCEPTED_RESERVATIONS_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingAcceptedReservations: false,
        reservationsAcceptedList: (_action$payload$data31 = action === null || action === void 0 || (_action$payload31 = action.payload) === null || _action$payload31 === void 0 ? void 0 : _action$payload31.data) !== null && _action$payload$data31 !== void 0 ? _action$payload$data31 : [],
        listAmenitiesAcceptedReservationsError: null,
        totalAcceptedReservationsCount: action.payload.headers['total-count'],
        totalAcceptedReservationsPages: action.payload.headers['total-pages']
      });
    case _variables.LIST_AMENITIES_ACCEPTED_RESERVATIONS_FAIL:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingAcceptedReservations: false,
        listAmenitiesAcceptedReservationsError: (_action$payload$data32 = action === null || action === void 0 || (_action$payload32 = action.payload) === null || _action$payload32 === void 0 ? void 0 : _action$payload32.data) !== null && _action$payload$data32 !== void 0 ? _action$payload$data32 : {}
      });
    case _variables.LIST_AMENITIES_PENDING_RESERVATIONS_REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingPendingReservations: true
      });
    case _variables.LIST_AMENITIES_PENDING_RESERVATIONS_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingPendingReservations: false,
        reservationsPendingList: (_action$payload$data33 = action === null || action === void 0 || (_action$payload33 = action.payload) === null || _action$payload33 === void 0 ? void 0 : _action$payload33.data) !== null && _action$payload$data33 !== void 0 ? _action$payload$data33 : [],
        listAmenitiesPendingReservationsError: null,
        totalPendingReservationsCount: action.payload.headers['total-count'],
        totalPendingReservationsPages: action.payload.headers['total-pages']
      });
    case _variables.LIST_AMENITIES_PENDING_RESERVATIONS_FAIL:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingPendingReservations: false,
        listAmenitiesPendingReservationsError: (_action$payload$data34 = action === null || action === void 0 || (_action$payload34 = action.payload) === null || _action$payload34 === void 0 ? void 0 : _action$payload34.data) !== null && _action$payload$data34 !== void 0 ? _action$payload$data34 : {}
      });
    case _variables.CREATE_AMENITY_REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: true
      });
    case _variables.CREATE_AMENITY_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: false,
        data: (_action$payload$data35 = action === null || action === void 0 || (_action$payload35 = action.payload) === null || _action$payload35 === void 0 ? void 0 : _action$payload35.data) !== null && _action$payload$data35 !== void 0 ? _action$payload$data35 : {},
        createAmenityError: null
      });
    case _variables.CREATE_AMENITY_FAIL:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: false,
        createAmenityError: (_action$payload$data36 = action === null || action === void 0 || (_action$payload36 = action.payload) === null || _action$payload36 === void 0 ? void 0 : _action$payload36.data) !== null && _action$payload$data36 !== void 0 ? _action$payload$data36 : {}
      });
    case _variables.EDIT_AMENITY_REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: true
      });
    case _variables.EDIT_AMENITY_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: false,
        data: (_action$payload$data37 = action === null || action === void 0 || (_action$payload37 = action.payload) === null || _action$payload37 === void 0 ? void 0 : _action$payload37.data) !== null && _action$payload$data37 !== void 0 ? _action$payload$data37 : {},
        editAmenityError: null
      });
    case _variables.EDIT_AMENITY_FAIL:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: false,
        editAmenityError: (_action$payload$data38 = action === null || action === void 0 || (_action$payload38 = action.payload) === null || _action$payload38 === void 0 ? void 0 : _action$payload38.data) !== null && _action$payload$data38 !== void 0 ? _action$payload$data38 : {}
      });
    case _variables.GET_AMENITY_REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: true
      });
    case _variables.GET_AMENITY_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: false,
        data: (_action$payload$data39 = action === null || action === void 0 || (_action$payload39 = action.payload) === null || _action$payload39 === void 0 ? void 0 : _action$payload39.data) !== null && _action$payload$data39 !== void 0 ? _action$payload$data39 : {},
        getAmenityError: null
      });
    case _variables.GET_AMENITY_FAIL:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: false,
        getAmenityError: (_action$payload$data40 = action === null || action === void 0 || (_action$payload40 = action.payload) === null || _action$payload40 === void 0 ? void 0 : _action$payload40.data) !== null && _action$payload$data40 !== void 0 ? _action$payload$data40 : {}
      });
    case _variables.CREATE_AMENITY_RESERVATION_REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingReservations: true
      });
    case _variables.CREATE_AMENITY_RESERVATION_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingReservations: false,
        createAmenityReservationError: null,
        reservationData: (_action$payload$data41 = action === null || action === void 0 || (_action$payload41 = action.payload) === null || _action$payload41 === void 0 ? void 0 : _action$payload41.data) !== null && _action$payload$data41 !== void 0 ? _action$payload$data41 : {}
      });
    case _variables.CREATE_AMENITY_RESERVATION_FAIL:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingReservations: false,
        createAmenityReservationError: (_action$payload$data42 = action === null || action === void 0 || (_action$payload42 = action.payload) === null || _action$payload42 === void 0 ? void 0 : _action$payload42.data) !== null && _action$payload$data42 !== void 0 ? _action$payload$data42 : {}
      });
    case _variables.DELETE_AMENITY_RESERVATION_REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingReservations: true
      });
    case _variables.DELETE_AMENITY_RESERVATION_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingReservations: false,
        deleteAmenityReservationError: null,
        reservationData: (_action$payload$data43 = action === null || action === void 0 || (_action$payload43 = action.payload) === null || _action$payload43 === void 0 ? void 0 : _action$payload43.data) !== null && _action$payload$data43 !== void 0 ? _action$payload$data43 : {}
      });
    case _variables.DELETE_AMENITY_RESERVATION_FAIL:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingReservations: false,
        deleteAmenityReservationError: (_action$payload$data44 = action === null || action === void 0 || (_action$payload44 = action.payload) === null || _action$payload44 === void 0 ? void 0 : _action$payload44.data) !== null && _action$payload$data44 !== void 0 ? _action$payload$data44 : {}
      });
    case _variables.EDIT_AMENITY_RESERVATION_REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingReservations: true
      });
    case _variables.EDIT_AMENITY_RESERVATION_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingReservations: false,
        editAmenityReservationError: null,
        reservationData: (_action$payload$data45 = action === null || action === void 0 || (_action$payload45 = action.payload) === null || _action$payload45 === void 0 ? void 0 : _action$payload45.data) !== null && _action$payload$data45 !== void 0 ? _action$payload$data45 : {}
      });
    case _variables.EDIT_AMENITY_RESERVATION_FAIL:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingReservations: false,
        editAmenityReservationError: (_action$payload$data46 = action === null || action === void 0 || (_action$payload46 = action.payload) === null || _action$payload46 === void 0 ? void 0 : _action$payload46.data) !== null && _action$payload$data46 !== void 0 ? _action$payload$data46 : {}
      });
    case _variables.GENERATE_LOST_STOCK_REPORT_REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        generateLostStockReportLoading: true
      });
    case _variables.GENERATE_LOST_STOCK_REPORT_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        generateLostStockReportLoading: false,
        generateLostStockReportError: null
      });
    case _variables.GENERATE_LOST_STOCK_REPORT_FAIL:
      return _objectSpread(_objectSpread({}, state), {}, {
        generateLostStockReportLoading: false,
        generateLostStockReportError: (_action$payload$data47 = action === null || action === void 0 || (_action$payload47 = action.payload) === null || _action$payload47 === void 0 ? void 0 : _action$payload47.data) !== null && _action$payload$data47 !== void 0 ? _action$payload$data47 : {}
      });
    case _variables.ACCEPT_RESERVATION_REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingAcceptReservation: true
      });
    case _variables.ACCEPT_RESERVATION_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingAcceptReservation: false,
        errorAcceptReservation: null
      });
    case _variables.ACCEPT_RESERVATION_FAIL:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingAcceptReservation: false,
        errorAcceptReservation: (_action$payload$data48 = action === null || action === void 0 || (_action$payload48 = action.payload) === null || _action$payload48 === void 0 ? void 0 : _action$payload48.data) !== null && _action$payload$data48 !== void 0 ? _action$payload$data48 : {}
      });
    case _variables.REJECT_RESERVATION_REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingRejectReservation: true
      });
    case _variables.REJECT_RESERVATION_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingRejectReservation: false,
        errorRejectReservation: null
      });
    case _variables.REJECT_RESERVATION_FAIL:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingRejectReservation: false,
        errorRejectReservation: (_action$payload$data49 = action === null || action === void 0 || (_action$payload49 = action.payload) === null || _action$payload49 === void 0 ? void 0 : _action$payload49.data) !== null && _action$payload$data49 !== void 0 ? _action$payload$data49 : {}
      });
    default:
      return state;
  }
};